import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface DashboardsState {
  loading: boolean;
  data: object;
  error: object;
}

const initialState: DashboardsState = {
  loading: false,
  data: [],
  error: {},
};

export const DashboardsSice = createSlice({
  name: "alert",
  initialState,
  reducers: {
    // actions
    loadDashboards: (state) => {
      return {
        ...state,
        loading: true,
        data: [],
        error: {},
      };
    },
    loadDashboardsSuceess: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: {},
      };
    },
    loadDashboardsError: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        loading: false,
        data: [],
        error: action.payload,
      };
    },
    reset: () => {
      return initialState;
    },
  },
});

// Action creators are generated for each case reducer function
export const { loadDashboards, loadDashboardsSuceess, loadDashboardsError } =
  DashboardsSice.actions;

export const DashboardsReducer = DashboardsSice.reducer;
